import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';

const useCreateAttachmentContentFromFile = () => {
  const { mutate, isLoading, reset, data } = useMutation(
    ({ data }: { data: { fileId: string; fileType: string } }) => {
      return BackendService.instance.presentations.createAttachmentContentFromFile(data);
    },
  );

  return {
    createFromFile: mutate,
    isCreating: isLoading,
    reset,
    createdContent: data,
  };
};
export default useCreateAttachmentContentFromFile;
